import { render, staticRenderFns } from "./Customiser.vue?vue&type=template&id=9f2ceeac&"
import script from "./Customiser.vue?vue&type=script&lang=js&"
export * from "./Customiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Customiser.vue"
export default component.exports